/**
 * Service de traduction et vulgarisation des messages d'erreur
 * Transforme les messages techniques du backend en messages compréhensibles pour les utilisateurs
 * Re-exports from errorMessages/index.ts
 */

export * from "./errorMessages/index";
